import { Component, OnInit } from '@angular/core';
import { NewPageList } from '../../core/models/new-page-list';
import {NewPageService } from '../../templates/new-page/service/new-page.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';

@Component({
  selector: 'app-static-comp',
  templateUrl: './static-comp.component.html',
  styleUrls: ['./static-comp.component.css'],
  providers:[NewPageService]
})
export class StaticCompComponent implements OnInit {

  constructor(private newPageService:NewPageService,private confirmationService: ConfirmationService) { }
  
  aboutUs :NewPageList;

  ngOnInit() {}

  _ref:any;
  
  confirmDelete() {
    this.confirmationService.confirm({
        message: 'Are you sure that you want to delete ?',
        accept: () => {
           this.remove();
        }
    });
  }
  remove(){
    this.newPageService.removeItem(this.aboutUs);
    this._ref.destroy();
  }  
  
  upItem(){
      this.newPageService.upItem(this.aboutUs);
  }

  downItem(){
    this.newPageService.downItem(this.aboutUs);
  }

}



// WEBPACK FOOTER //
// /app/src/app/layout/static-comp/static-comp.component.ts